import { FC, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import styled from 'styled-components';
import { useGetHeroConversationById, chatActions, useAppDispatch } from '@vs-online-only-app/state';
import { CenteredLoader } from '@vs-online-only-app/ui';
import SelectedConversationSection from '../components/selected-conversation/SelectedConversationSection';
import SelectedConversationPlaceholder from '../components/selected-conversation/SelectedConversationPlaceholder';

const SelectionConversationSectionWrapper = styled.div`
  display: flex;
  background-color: white;
  border-left: 1px solid ${({ theme }) => theme.palette.divider};
  overflow: hidden;
  height: 100%;
  width: 100%;
`;

const ConversationView: FC = () => {
  const [searchParams] = useSearchParams();
  const dispatch = useAppDispatch();
  const conversationId = searchParams.get('conversationId') || '';

  const { data: heroConversation, isLoading } = useGetHeroConversationById(conversationId);

  useEffect(() => {
    if (!heroConversation) return;
    dispatch(chatActions.setSelectedConversation(heroConversation));
  }, [heroConversation, dispatch]);

  if (isLoading) {
    return <CenteredLoader large />;
  }

  if (!heroConversation) {
    return <SelectedConversationPlaceholder />;
  }

  return (
    <SelectionConversationSectionWrapper>
      <SelectedConversationSection />
    </SelectionConversationSectionWrapper>
  );
};

export default ConversationView;
